import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';

export const OrderTotalEntry = ({ k, v }) => (
  <View style={styles.row}>
    <View style={styles.col60}>
      <Text>{k}</Text>
    </View>
    <View style={styles.sumRight}>
      <Text>{v}</Text>
    </View>
  </View>
);
